import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function MosaVideo() {
  const gridRef = useRef();

  useEffect(() => {
    const ctx = gsap.context(() => {
      const grid = gridRef.current;
      const cells = grid.querySelectorAll(".cell:not(.video)");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: grid,
          //   start: "40% center",
          start: "top center ",
          end: "+=1200",
          scrub: true,
          //   pin: true,
          pinType: "transform",
          anticipatePin: 1,
          //   markers: true,
        },
      });

      tl.fromTo(
        cells,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          stagger: 0.15,
          ease: "power2.out",
        }
      ).to(cells, {
        y: -100,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        ease: "power2.in",
      });
    }, gridRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="MosaVideo">
      <div className="grid" ref={gridRef}>
        {/* ligne 1  */}
        <div className="cell double">
          <img src="/img/gifMosa/exo.gif" alt="Logo" className="logo" />
        </div>
        <div className="cell">
          <img src="/img/gifMosa/create-gif.gif" alt="Logo" className="logo" />
        </div>
        <div className="cell">
          <img src="/img/gifMosa/cross.gif" alt="Logo" className="logo" />
        </div>
        <div className="cell double">
          <img src="/img/gifMosa/fall.gif" alt="Logo" className="logo" />
        </div>

        {/* ligne 2 */}
        <div className="cell doubleHeight">
          <img src="/img/gifMosa/scene-store.gif" alt="Logo" className="logo" />
        </div>
        <div className="cell video">
          <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/1052214733?h=5406f991dd"
            width="100%"
            height="auto"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
        <div className="cell video">
          <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/1056389660?h=683bff1b34"
            width="100%"
            height="auto"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
        <div className="cell tripleHeight">
          <img src="/img/gifMosa/plate.gif" alt="Logo" className="logo" />
        </div>

        {/* ligne 3 */}
        <div className="cell double">
          <img src="/img/gifMosa/OXYGEN.gif" alt="Logo" className="logo" />
        </div>
        <div className="cell">
          <img
            src="/img/gifMosa/personnal-branding.gif"
            alt="Logo"
            className="logo"
          />
        </div>
        <div className="cell double">
          <img src="/img/gifMosa/object-3D.gif" alt="Logo" className="logo" />
        </div>
      </div>
    </section>
  );
}

export default MosaVideo;
